import { trigger, state, style, transition, animate, group, query, stagger, keyframes} from '@angular/animations';

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    state('open', style({
      'height': '*',
      'opacity': 1
    })),
    state('close', style({
      'height': '0px',
      'opacity': 0
    })),
    transition('open <=> close', animate(150))
  ]),
]
